export default function blogContent() {
    const qs = (sel, ctx = document) => ctx.querySelector(sel);
    const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

    const root = qs("[data-blog-content]");
    if (!root) return;

    const filter = qs("[data-blog-filter]", root);
    const grid = qs("[data-blog-grid]", root);
    const pagination = qs("[data-blog-pagination]", root);

    if (!filter || !grid || !pagination) return;

    let currentTerm = "featured";
    let currentPage = 1;
    let isLoading = false;

    const setActiveTerm = (term) => {
        currentTerm = term;
        currentPage = 1;

        qsa("[data-term]", filter).forEach((btn) => {
            btn.classList.toggle(
                "is-active",
                String(btn.dataset.term) === String(term),
            );
        });
    };

    const getAjaxUrl = () => {
        if (window.usAjax && window.usAjax.ajaxurl)
            return window.usAjax.ajaxurl;
        if (window.phpVars && window.phpVars.ajaxUrl)
            return window.phpVars.ajaxUrl;
        return "";
    };

    const getNonce = () => {
        if (window.usAjax && window.usAjax.nonce) return window.usAjax.nonce;
        if (window.phpVars && window.phpVars.nonce) return window.phpVars.nonce;
        return "";
    };

    const request = async () => {
        if (isLoading) return;

        const ajaxUrl = getAjaxUrl();
        if (!ajaxUrl) return;

        isLoading = true;
        root.classList.add("is-loading");

        const fd = new FormData();
        fd.append("action", "blog_posts_filter");
        fd.append("nonce", getNonce());
        fd.append("term", currentTerm);
        fd.append("paged", String(currentPage));

        try {
            const res = await fetch(ajaxUrl, {
                method: "POST",
                body: fd,
                credentials: "same-origin",
            });

            const json = await res.json();

            if (!json || !json.success) {
                root.classList.remove("is-loading");
                isLoading = false;
                return;
            }

            grid.innerHTML = json.data.grid || "";
            pagination.innerHTML = json.data.pagination || "";
        } catch (e) {
            null;
        }

        root.classList.remove("is-loading");
        isLoading = false;
    };

    filter.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-term]");
        if (!btn) return;

        const term = btn.dataset.term || "featured";
        if (String(term) === String(currentTerm)) return;

        setActiveTerm(term);
        request();
    });

    pagination.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-page]");
        if (!btn) return;

        const page = parseInt(btn.dataset.page || "1", 10);
        if (!page || page === currentPage) return;

        currentPage = page;
        request();
    });
}
